import apiClient from './client';
import { Menu, MenuCategory } from '../types/admin';

export const fetchMenus = async (): Promise<Menu[]> => {
  const { data } = await apiClient.get<Menu[]>('/appmanage/menus');
  return data;
};

export const setMenuSoldOut = async (id: number, isSoldOut: boolean): Promise<void> => {
  await apiClient.patch(`/appmanage/menus/${id}/sold-out`, { isSoldOut });
};

export const fetchMenuCategories = async (): Promise<MenuCategory[]> => {
  const { data } = await apiClient.get<MenuCategory[]>('/appmanage/menus/categories');
  return data;
};

export interface CreateMenuPayload {
  categoryId?: number;
  newCategoryName?: string;
  name: string;
  price: number;
  image?: File | null;
}

// 사진 파일을 함께 보내야 하므로 multipart/form-data로 전송한다.
export const createMenu = async (payload: CreateMenuPayload): Promise<{ id: number; imageUrl: string | null }> => {
  const form = new FormData();
  if (payload.categoryId !== undefined) form.append('categoryId', String(payload.categoryId));
  if (payload.newCategoryName !== undefined) form.append('newCategoryName', payload.newCategoryName);
  form.append('name', payload.name);
  form.append('price', String(payload.price));
  if (payload.image) form.append('image', payload.image);

  const { data } = await apiClient.post<{ id: number; imageUrl: string | null }>('/appmanage/menus', form);
  return data;
};

// 서버는 이미지 경로를 /uploads/... 상대 경로로 저장하므로 API 서버 주소를 붙여 쓴다.
export const resolveImageUrl = (path: string | null): string | null => {
  if (!path) return null;
  if (/^https?:\/\//.test(path)) return path;
  return new URL(path, apiClient.defaults.baseURL).toString();
};
